export default __webpack_public_path__ + "static/2-select-github-8dcd29633d5a6e8bdbb457011e1b3491.png";